<div class="container">
    <div class="control _cursor-pointer noselect" (click)="minus()">
        <i class="fa-light fa-minus"></i>
    </div>

    <span class="value">{{value}}</span>

    <div class="control _cursor-pointer noselect" (click)="plus()">
        <i class="fa-light fa-plus"></i>
    </div>
</div>
